var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSimplification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5625 9.5H2.9375C2.68886 9.5 2.4504 9.40123 2.27459 9.22541C2.09877 9.0496 2 8.81114 2 8.5625V2.9375C2 2.68886 2.09877 2.4504 2.27459 2.27459C2.4504 2.09877 2.68886 2 2.9375 2H8.5625C8.81114 2 9.0496 2.09877 9.22541 2.27459C9.40123 2.4504 9.5 2.68886 9.5 2.9375V8.5625C9.5 8.81114 9.40123 9.0496 9.22541 9.22541C9.0496 9.40123 8.81114 9.5 8.5625 9.5Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5625 22H2.9375C2.68886 22 2.4504 21.9012 2.27459 21.7254C2.09877 21.5496 2 21.3111 2 21.0625V15.4375C2 15.1889 2.09877 14.9504 2.27459 14.7746C2.4504 14.5988 2.68886 14.5 2.9375 14.5H8.5625C8.81114 14.5 9.0496 14.5988 9.22541 14.7746C9.40123 14.9504 9.5 15.1889 9.5 15.4375V21.0625C9.5 21.3111 9.40123 21.5496 9.22541 21.7254C9.0496 21.9012 8.81114 22 8.5625 22Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0625 9.5H15.4375C15.1889 9.5 14.9504 9.40123 14.7746 9.22541C14.5988 9.0496 14.5 8.81114 14.5 8.5625V2.9375C14.5 2.68886 14.5988 2.4504 14.7746 2.27459C14.9504 2.09877 15.1889 2 15.4375 2H21.0625C21.3111 2 21.5496 2.09877 21.7254 2.27459C21.9012 2.4504 22 2.68886 22 2.9375V8.5625C22 8.81114 21.9012 9.0496 21.7254 9.22541C21.5496 9.40123 21.3111 9.5 21.0625 9.5Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0625 22H15.4375C15.1889 22 14.9504 21.9012 14.7746 21.7254C14.5988 21.5496 14.5 21.3111 14.5 21.0625V15.4375C14.5 15.1889 14.5988 14.9504 14.7746 14.7746C14.9504 14.5988 15.1889 14.5 15.4375 14.5H21.0625C21.3111 14.5 21.5496 14.5988 21.7254 14.7746C21.9012 14.9504 22 15.1889 22 15.4375V21.0625C22 21.3111 21.9012 21.5496 21.7254 21.7254C21.5496 21.9012 21.3111 22 21.0625 22Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSimplification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Simplification.cddd67198a78ca854edfbde9da78eada.svg";